import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { RM } from '../lib/rm';

// Full-screen overlay: draws the "neuro" mark, reveals the wordmark, then fades.
// `onDone` fires as the fade begins so App can reveal the stage with overlap.
export function Entrance({ onDone }: { onDone: () => void }) {
  const [gone, setGone] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const pathRef = useRef<SVGPathElement>(null);
  const wordRef = useRef<HTMLDivElement>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (RM) {
      onDone();
      setGone(true);
      return;
    }

    const path = pathRef.current!;
    const wordEl = wordRef.current!;
    const len = path.getTotalLength();
    gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });

    const chars = [...'neuro'].map((c) => {
      const s = document.createElement('span');
      s.className = 'ch';
      s.textContent = c;
      wordEl.appendChild(s);
      return s;
    });
    gsap.set(chars, { opacity: 0, y: 12 });

    const tl = gsap.timeline();
    tl.to(path, { strokeDashoffset: 0, duration: 1.1, ease: 'power2.inOut' })
      .to(chars, { opacity: 1, y: 0, duration: 0.5, stagger: 0.05, ease: 'back.out(2)' }, '-=.4')
      .to({}, { duration: 0.35 })
      .to(rootRef.current, {
        opacity: 0,
        duration: 0.6,
        onStart: onDone,
        onComplete: () => setGone(true),
      });

    return () => {
      tl.kill();
    };
  }, [onDone]);

  if (gone) return null;

  return (
    <div className="enter" ref={rootRef}>
      <div className="mk">
        <svg viewBox="0 0 180 80" width={180} height={80}>
          <path
            ref={pathRef}
            d="M12,52 C20,20 44,20 50,44 C55,64 74,66 84,44 C92,26 108,26 112,46 C115,62 132,64 142,44 C150,28 166,30 168,50"
          />
        </svg>
        <div className="word" ref={wordRef}>
          {RM ? 'neuro' : ''}
        </div>
      </div>
    </div>
  );
}
